import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ConfigContext = createContext(null);

const FALLBACK = {
  brand_name: "ASSURE CONSEIL",
  logo_url: "/assur-conseil-logo.png",
  contact_email: "",
  contact_phone: "",
  address: "",
  orias_number: "",
  legal_entity: "",
  demo_mode: false,
};

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(FALLBACK);

  const refresh = () =>
    api.get("/config").then((r) => setConfig({ ...FALLBACK, ...r.data })).catch(() => {});

  useEffect(() => {
    refresh();
  }, []);

  return (
    <ConfigContext.Provider value={{ config, refresh }}>{children}</ConfigContext.Provider>
  );
}

export const useConfig = () => useContext(ConfigContext);
